import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import gsap from 'gsap';

export default function initCrossSell() {
    const crossSellBlocks = document.querySelectorAll('.cross-sell:not(.cross-sell--artistic)');

    crossSellBlocks.forEach(block => {
        const swiperContainer = block.querySelector('.swiper');
        const slides = block.querySelectorAll('.swiper-slide');

        // Only init if more than one slide
        if (slides.length <= 1) return;

        // Swiper init logic
        const swiper = new Swiper(swiperContainer, {
            modules: [Navigation],
            loop: true,
            speed: 600,
            navigation: {
                nextEl: Array.from(block.querySelectorAll('.swiper-button-next')),
                prevEl: Array.from(block.querySelectorAll('.swiper-button-prev')),
            },
            on: {
                init: function () {
                    animateContent(this.slides[this.activeIndex]);
                },
                slideChangeTransitionStart: function () {
                    animateContent(this.slides[this.activeIndex]);
                }
            }
        });
    });

    initArtisticAnims();

    function initArtisticAnims() {
        const artisticBlocks = document.querySelectorAll('.cross-sell--artistic');
        artisticBlocks.forEach(block => {
            const image = block.querySelector('.cross-sell__image');
            if (!image) return;

            gsap.fromTo(image, {
                width: () => window.innerWidth > 991 ? "50vw" : "70vw",
            }, {
                width: () => window.innerWidth > 991 ? "334px" : "217px",
                ease: "power2.inOut",
                scrollTrigger: {
                    trigger: block,
                    start: "top bottom",
                    end: "top 20%",
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            });
        });
    }

    function animateContent(activeSlide) {
        const elements = activeSlide.querySelectorAll('.subtitle, h2, p, .btn, .cross-sell__caption');
        if (elements.length === 0) return;

        gsap.fromTo(elements, {
            opacity: 0,
            y: 20
        }, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            ease: 'power3.out',
            overwrite: true,
            delay: 0.4
        });
    }
}
